import { render, staticRenderFns } from "./chart-register-timeout.vue?vue&type=template&id=61d392b6&lang=pug&"
import script from "./chart-register-timeout.vue?vue&type=script&lang=ts&"
export * from "./chart-register-timeout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports